<div id="js-page09" class="page">
  @switch (type()) {
  @case (1) {
  <app-workingholiday></app-workingholiday>
  }
  @case (2) {
  <app-languageschool></app-languageschool>
  }
  @case (3) {
  <app-intern></app-intern>
  }
  @case (4) {
  <app-coop></app-coop>
  }
  @case (5) {
  <app-volunteer></app-volunteer>
  }
  @case (6) {
  <app-universities></app-universities>
  }
  }
  @if (!hideRecommend()) {
    <section class="sb-recomend">
      <div class="sb-feature__headWrapper">
        <img src="https://file.mysquadbeyond.com/uploads/article_photo/photo/5330417/cfaed7f6-a466-4936-9039-c9140f639b0d.png" alt="" class="sb-feature__headImg lazyload">
        <p class="sb-feature__head u-text-center u-text-medium">あなたにおすすめの<br>留学・ワーホリ<br>エージェントは</p>
      </div>
      <div class="sb-recomend__wrapper">
        <div class="sb-recomend__titleWrapper">
          <img src="https://file.mysquadbeyond.com/uploads/article_photo/photo/5330412/94d92293-9013-45e7-bd99-da82a811cc9f.svg" alt="No.1" class="sb-recomend__no lazyload">
          <h2 class="sb-recomend__title u-text-center">夢カナ留学</h2>
        </div>
        <p class="sb-recomend__text">夢カナ留学は、実質0円で留学やワーキングホリデーを希望する人に対し、渡航前から帰国後まで一貫したサポートを行うエージェントです。希望に沿ったプランの提案、ネイティブ講師による英語学習支援、24時間の現地サポート、帰国後のキャリア支援まで幅広く対応しています。</p>
      </div>
    </section>
  } @else {
    <div class="sb-form__read u-text-center u-text-medium no-recommend">
      <img src="https://file.mysquadbeyond.com/uploads/article_photo/photo/5402492/c7198aad-1da5-4bff-819a-66eaeb16097a.jpg" alt="↓" class="sb-form__arrow lazyload">
      <img src="https://file.mysquadbeyond.com/uploads/article_photo/photo/5402505/7c35ff8d-102d-451f-a182-6989decbafd8.jpg" alt="↓" class="sb-form__arrow lazyload">
    </div>
  }
    <section class="sb-form">
      @if (!hideRecommend()) {
        <div class="ab-form__read u-text-center u-text-medium">
          <p>このまま<br>無料カウンセリングに<br>予約できます</p>
          <div class="ab-form__readNote u-text-medium">※1分程度で入力できます</div>
          <img src="https://file.mysquadbeyond.com/uploads/article_photo/photo/5330413/c561f787-98a5-401b-a59f-f5aeb17c95a5.svg" alt="↓" class="ab-form__arrow lazyload">
        </div>
        <img src="https://file.mysquadbeyond.com/uploads/article_photo/photo/5330420/2b7b31bc-bb7a-4b34-ad26-7dbfb4764f4b.png" alt="このサイト限定の予約特典 ¥100,000OFF" class="sb-form__img lazyload">
      }
      <div class="sb-form__note u-text-center u-text-medium">※残り枠数がわずかです！</div>
      <app-lp-consulting-reservation id="schedules" [completeUrl]="completeUrl()" [lpType]="lpType()"></app-lp-consulting-reservation>
    </section>
</div>
